import { apiGatewayUrl } from '../../config/environment';

export const logout = (idToken: string, language = 'en') => {
  const cancelRedirectUrl = encodeURIComponent(window.location.href);

  window.open(
    `${apiGatewayUrl}/end-session?cancel_redirect=${cancelRedirectUrl}&id_token=${idToken}&language=${language}`,
    '_self',
  );
};
